import { isDevMode } from "@scripts/helpers/utils";

export default new Proxy(console, {
	get(target, prop) {
		if (isDevMode()) {
			return Reflect.get(...arguments);
		}

		if (typeof target[prop] === 'function') {
			return () => {};
		}

		return undefined;
	}
});
